import styled from 'styled-components';

const StyledSelect = styled('select')`
  width: 150px;
  min-height: 25px;
`;
export { StyledSelect };
